import { useMutation } from "@tanstack/react-query";
import { authApi } from "../api/authApi";
import { useAuth } from "./useAuth";

export function useLoginMutation() {
  const { login } = useAuth();
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: (data) => login(data),
  });
}
